import { Component, } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { LoginService } from './services/login.service';
import { NavigationService } from './services/navigation.service';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'facturaAgil';

  constructor(
    private router: Router,
    private navigationService: NavigationService,
    public loginService: LoginService,
    private msalService: MsalService,

  ) {
    this.msalService.initialize();
    
  }

  ngOnInit() {
    this.loginService.initMsalAD()
    this.navigationService.disableNavigation();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.scrollToTop();
      }
    });
    if (this.msalService.instance.getAllAccounts().length > 0) {
      this.router.navigate(['/home']);
    }
    else{
      this.router.navigate(['/login']);
    }
  }

  private scrollToTop(): void {
    window.scrollTo(0, 0);
  }

}
